import { useMemo } from 'react'
import useAuthStore from '../stores/useAuthStore'

/**
 * Custom hook to access user permissions
 * Returns permissions for the logged-in sales representative
 */
export const usePermissions = () => {
  const { user } = useAuthStore()

  const permissions = useMemo(() => {
    console.log('🔐 [usePermissions] Full user object:', user)

    const salesRep = user?.sales_representative

    console.log('🔐 [usePermissions] Sales Rep object:', salesRep)

    // Use explicit checks to handle boolean false and 0 correctly
    const perms = {
      canEdit: salesRep ? Boolean(salesRep.can_edit) : true, // Default to true only if no salesRep
      canDelete: salesRep ? Boolean(salesRep.can_delete) : false,
      canAddDiscount: salesRep ? Boolean(salesRep.can_add_discount) : false,
      isActive: salesRep ? Boolean(salesRep.status) : true,
    }

    // Debug log
    console.log('🔐 [usePermissions] Raw salesRep data:', {
      can_edit: salesRep?.can_edit,
      can_delete: salesRep?.can_delete,
      can_add_discount: salesRep?.can_add_discount,
      types: {
        can_edit: typeof salesRep?.can_edit,
        can_delete: typeof salesRep?.can_delete,
        can_add_discount: typeof salesRep?.can_add_discount,
      }
    })
    console.log('🔐 [usePermissions] Computed permissions:', perms)

    return perms
  }, [user])

  return permissions
}

export default usePermissions
